import axios from "axios";
import { ENDPOINTS } from "./endpoints";

export const getSurveyMonkeyFolders = async (params = {}) => {
  try {
    const response = await axios.get(ENDPOINTS.SURVEY.GET_SM_FOLDERS, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAvailableSurveys = async (params = {}) => {
  try {
    const response = await axios.get(ENDPOINTS.SURVEY.GET_AVAILABLE, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAssignableStudents = async (params) => {
  try {
    const response = await axios.get(ENDPOINTS.SURVEY.GET_ASSIGNABLE_STUDENTS, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveys = async (params = {}) => {
  try {
    const response = await axios.get(ENDPOINTS.SURVEY.GET, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSurvey = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.SURVEY.CREATE, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveyById = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSurvey = async (id, data) => {
  try {
    const response = await axios.put(`${ENDPOINTS.SURVEY.UPDATE}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSurvey = async (id) => {
  try {
    const response = await axios.delete(`${ENDPOINTS.SURVEY.DELETE}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveyResults = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.RESULTS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveyCompletion = async (id, params = {}) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.COMPLETION}`, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const exportSurveyCompletion = async (id, params = {}) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.EXPORT_COMPLETION}`, {
      params,
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveyAnalytics = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.ANALYTICS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentSurveyResult = async (id, studentId) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/students/${studentId}/${ENDPOINTS.SURVEY.STUDENT_RESULT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSurveySmResponses = async (id) => {
  try {
    const response = await axios.get(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.SM_RESPONSES}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const remindPendingStudents = async (id) => {
  try {
    const response = await axios.post(`${ENDPOINTS.SURVEY.GET_SURVEY}/${id}/${ENDPOINTS.SURVEY.REMIND}`, {});
    return response;
  } catch (error) {
    throw error;
  }
};
